import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { roles } from '../../utils/constants';
import DesignerTab from '../Designer/DesignerTab';
import DesignerHome from '../Designer/DesignerHome';
import OrderBookingHome from '../Designer/OrderBooking/OrderBookingHome';
import ContentWriterAlphaHome from '../ContentWriter/ContentWriterHome';
import ContentWriterOrderBookingHome from '../ContentWriter/OrderBooking/ContentWriterHome';
import BookingCreativesAssign from '../creatives/BookingCreativesAssign';

const VIEWS = [
  { key: 'alpha', label: 'Alpha' },
  { key: 'non-alpha', label: 'Non Alpha' },
];

// role -> { alpha view, non-alpha (sales creative order booking) view }
const VIEW_COMPONENTS = {
  [roles.ops]: { alpha: DesignerTab, 'non-alpha': BookingCreativesAssign },
  [roles.designer]: { alpha: DesignerHome, 'non-alpha': OrderBookingHome },
  [roles.content_writer]: { alpha: ContentWriterAlphaHome, 'non-alpha': ContentWriterOrderBookingHome },
};

const DesignerRequests = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const role = localStorage.getItem('role');
  const view = searchParams.get('view') === 'non-alpha' ? 'non-alpha' : 'alpha';
  const ViewComponent = VIEW_COMPONENTS[role]?.[view];

  // Only `view` is kept: the inner pages own the `tab` param.
  const changeView = (key) => setSearchParams({ view: key });

  if (!ViewComponent) return null;

  return (
    <div>
      <div className="px-4 pt-3">
        <div role="tablist" className="inline-flex gap-1 rounded-xl bg-slate-100 p-1">
          {VIEWS.map((v) => {
            const isActive = v.key === view;
            return (
              <button
                key={v.key}
                role="tab"
                type="button"
                aria-selected={isActive}
                onClick={() => changeView(v.key)}
                className={`rounded-lg px-4 py-2 text-sm font-medium transition ${
                  isActive ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'
                }`}
              >
                {v.label}
              </button>
            );
          })}
        </div>
      </div>
      {/* key forces a clean remount (sockets/polling/tab state) when switching views */}
      <ViewComponent key={view} />
    </div>
  );
};

export default DesignerRequests;
